import React from 'react'

const Footer = () => {
  return (
    <div className='mt-16 h-12 bg-main-blue w-[100%] flex items-center justify-center font-poppins text-white font-light text-[15px] mb-[-1%]'>
        <p>Copyright @ 2023. All rights reserved.</p>
        <p className='mx-5'>Privacy Policy</p>
        <p>Terms & Conditions</p>
    </div>
  )
}

export default Footer